import styled from 'styled-components';

type Props = {
  maxWidth?: string;
  contentWidth?: string;
  contentHeight?: string;
  borderRadius?: string;
  paddingTop?: string;
  padding?: string;
};

export const ModalContainer = styled.div<Props>`
  position: fixed;
  z-index: 1;
  padding: 32px;
  padding-top: ${props => (props.paddingTop ? props.paddingTop : '100px')};
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.4);
`;

export const ModalContent = styled.div<Props>`
  background-color: #fefefe;
  margin: auto;
  padding: ${props => (props.padding ? props.padding : '32px')};
  border: 1px solid #888;
  :85% ;
  width: ${props => (props.contentWidth ? props.contentWidth : '650px')};
  height: ${props => (props.contentHeight ? props.contentHeight : 'auto')};
  max-width: ${props => (props.maxWidth ? props.maxWidth : '650px')};
  border-radius: ${props => (props.borderRadius ? props.borderRadius : '16px')};

  @media (max-width: 650px) {
    width: 100%;
  }
`;

export const ModalHeader = styled.div`
  font-size: 20px;
  padding-bottom: 20px;
  line-height: 24px;
  letter-spacing: -0.25px;
  border-bottom: solid 1px #e6e6e6;
  display: flex;
  justify-content: space-between;
  position: relative;
  button {
    cursor: pointer;
    border: 0;
    background-color: transparent;
    position: absolute;
    top: -15px;
    right: -15px;
  }
`;

export const ModalHeaderCustom = styled.div`
  font-size: 20px;
  padding-top: 12px;
  line-height: 24px;
  letter-spacing: -0.25px;
  position: relative;

  button {
    cursor: pointer;
    border: 0;
    background-color: transparent;
    position: absolute;
    top: -20px;
    right: -20px;
  }
`;

export const TextHeaderCustom = styled.div`
  font-size: 28px;
  letter-spacing: -0.25px;
  display: flex;
  font-family: 'Inter';
  margin-top: 8px;
  line-height: 110%;
  justify-content: space-between;
  font-family: Inter;
  font-weight: 700;
  @media (max-width: 650px) {
    font-size: 24px;
  }
`;

export const ModalBody = styled.div`
  font-size: 16px;
  line-height: 20px;
  margin: 32px 0 !important;
  padding: 0;
  color: #333333;

  @media (max-width: 650px) {
    padding: 0;
    margin: 24px 0 !important;
  }
`;

export const ModalB2BContainer = styled.div`
  font-size: 18px;
  line-height: 150%;
  padding: 0;
  color: #333333;
  padding: 32px 0;

  p {
    padding: 4px 0;
  }

  @media (max-width: 650px) {
    font-size: 16px;
    padding: 24px 0;
  }
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 8px 32px 32px 32px;

  > button {
    width: 100%;
  }
  > button:first-child {
    margin-bottom: 24px;
  }

  @media (max-width: 650px) {
    width: 100%;
    justify-content: flex-end;
    padding: 8px 24px 24px 24px;
    > div {
      margin-right: 5px;
    }
    > button:first-child {
      margin-bottom: 16px;
    }
  }
`;

export const TextHeaderModal = styled.h1`
  font-family: 'Inter';
  font-size: 20px;
  font-weight: bold;
  width: 100%;
`;
